import React from "react";
import { threeMReportApis } from "../../../../api/ThreeMReport";
import MonthlyScheduleDrawer from "../shared/MonthlyScheduleDrawer";
import { ManpowerSummaryRow } from "./manpowerShared";

// Per-labour-item monthly schedule. Manpower identity is composite — PRW rows
// key on manpowerNormId, OTHERS rows on (laborTypeId, laborCategoryId,
// workUomId) where an ABSENT id means IS NULL server-side, which is what keeps
// the "Unlinked labour" row drillable. The head here is the source, since
// manpower has no category column of its own.

const ManpowerMonthlyScheduleDrawer: React.FC<{
  open: boolean;
  projectId?: number | string;
  row?: ManpowerSummaryRow | null;
  phaseId?: number | string;
  activityId?: number | string;
  onClose: () => void;
  getContainer?: () => HTMLElement;
}> = ({ open, projectId, row, phaseId, activityId, onClose, getContainer }) => {
  const source = row?.source === "OTHERS" ? "OTHERS" : "PRW";
  return (
    <MonthlyScheduleDrawer
      open={open}
      itemName={row?.itemName}
      itemCode={row?.itemCode}
      headLabel={source === "PRW" ? "PRW" : "Others"}
      headColor={source === "PRW" ? "blue" : "orange"}
      uomName={row?.uomName}
      entityLabel="labour item"
      fetchKey={
        projectId && row
          ? [
              projectId,
              source,
              row.manpowerNormId ?? "",
              row.laborTypeId ?? "",
              row.laborCategoryId ?? "",
              row.workUomId ?? "",
              phaseId ?? "",
              activityId ?? "",
            ].join("|")
          : ""
      }
      fetchSchedule={() =>
        threeMReportApis.get3MManpowerMonthlySchedule(projectId as number, {
          source,
          manpowerNormId: row?.manpowerNormId,
          laborTypeId: row?.laborTypeId,
          laborCategoryId: row?.laborCategoryId,
          workUomId: row?.workUomId,
          phaseId,
          activityId,
        })
      }
      onClose={onClose}
      getContainer={getContainer}
    />
  );
};

export default ManpowerMonthlyScheduleDrawer;
